import React from "react"
import { previewPosterImage } from "./utils"

const PosterReview = ({ data }) => {
    return <div className="img-prev-outer">
        <img src={previewPosterImage["7b8ad234"]} alt="random-screenshot" />
    </div>
}

export default PosterReview